import React, { useContext } from 'react';
import { withPrefix } from 'gatsby';
import Breadcrumbs from '@vfuk/core-breadcrumbs';
import { ThemeProvider } from 'styled-components';
import WS10Theme from '@vfuk/core-theme-ws10';
import { BreadcrumbWrapper } from './SWBreadcrumb.styles';
import { DirectionContext } from '../../../../contexts/DirectionContext';

WS10Theme.setBaseAssetLocation(withPrefix('/assets/'));

export const CONTENTFUL_SECTION_SW_BREADCRUMB = 'ContentfulSectionSwBreadcrumb';

const runBreadcrumbEventData = async sData => {
  if (window.onBreadcrumbsUserEvent && sData) {
    try {
      const finished = await window.onBreadcrumbsUserEvent('breadcrumb', {
        ...sData,
      });
    } catch (e) {
      console.log(
        'onBreadcrumbsUserEvent failed - please check the Breadcrumb SEO script JSON and that a SeoInteractionScript is correctly set up.'
      );
    }
  }
};

const SWBreadcrumb = ({ items, location = 'SWBreadcrumb' }) => {
  const direction = useContext(DirectionContext);

  return (
    <ThemeProvider theme={WS10Theme}>
      <BreadcrumbWrapper direction={direction}>
        <Breadcrumbs
          onClick={() => runBreadcrumbEventData({ location: location })}
          items={items}
        />
      </BreadcrumbWrapper>
    </ThemeProvider>
  );
};

export default SWBreadcrumb;
